import { defineMessages } from 'react-intl';

export const subscriptionsMessages = defineMessages({
    subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    subscriptionsTableBadge: {
        id: 'subscriptions-table-badge',
        defaultMessage: 'Subscriptions',
    },
    refNumber: {
        id: 'ref-number',
        defaultMessage: 'Ref number',
    },
    externalId: {
        id: 'external-id',
        defaultMessage: 'External ID',
    },
    startDate: {
        id: 'start-date',
        defaultMessage: 'Start date',
    },
    endDate: {
        id: 'end-date',
        defaultMessage: 'End date',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    cancelled: {
        id: 'cancelled',
        defaultMessage: 'Cancelled',
    },
    endedSubscription: {
        id: 'ended-subscription',
        defaultMessage: 'Past',
    },
    frozen: {
        id: 'frozen',
        defaultMessage: 'Frozen',
    },
    cancelledAt: {
        id: 'cancelled-at',
        defaultMessage: 'Cancelled at',
    },
    lockedAt: {
        id: 'locked-at',
        defaultMessage: 'Locked at',
    },
    stoppedOn: {
        id: 'stopped-on',
        defaultMessage: 'Stopped on',
    },
    activeBilling: {
        id: 'active-billing',
        defaultMessage: 'Active billing',
    },
    createSubscriptionSuccess: {
        id: 'create-subscription-success',
        defaultMessage: 'Subscription created',
    },
    createSubscriptionSuccessDescription: {
        id: 'create-subscription-success-description',
        defaultMessage: 'The subscription has been successfully created.',
    },
    addSubscriptionSubtitle: {
        id: 'add-subscription-subtitle',
        defaultMessage: 'Create a new subscription',
    },
    deleteSubscription: {
        id: 'delete-subscription',
        defaultMessage: 'Delete subscription',
    },
    deleteSubscriptionSuccess: {
        id: 'delete-subscription-success',
        defaultMessage: 'Subscription deleted',
    },
    deleteSubscriptionSuccessDescription: {
        id: 'delete-subscription-success-description',
        defaultMessage: 'The subscription has been successfully deleted.',
    },
    confirmDeleteSubscription: {
        id: 'confirm-delete-subscription',
        defaultMessage: 'Are you sure you want to delete this subscription? This action cannot be undone.',
    },
    deleteSubscriptionSubtitle: {
        id: 'delete-subscription-subtitle',
        defaultMessage: 'Permanently delete subscription',
    },
    editSubscriptionSubtitle: {
        id: 'edit-subscription-subtitle',
        defaultMessage: 'Edit subscription',
    },
    updateSubscriptionSuccess: {
        id: 'update-subscription-success',
        defaultMessage: 'The subscription was updated',
    },
    updateSubscriptionSuccessDescription: {
        id: 'update-subscription-success-description',
        defaultMessage: 'The subscription has been successfully updated.',
    },
    subscriptionDashboard: {
        id: 'subscription-dashboard',
        defaultMessage: 'Subscription dashboard',
    },
    backToAllSubscriptions: {
        id: 'back-to-all-subscriptions',
        defaultMessage: 'Back to all subscriptions',
    },
});
